import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { fabric } from 'fabric';
import { computed, inject, onMounted, PropType, ref } from 'vue';

import {getDomainPath} from '@/services';

import { InspectionImage } from '@/entities/inspection-image/types';
import {
  AssemblerRootExposition,
  FabricExposition,
  injectionKey,
} from '@/core/components/data-display/Fabric/fabric.shared';

import { NkFabricGroup, NkFabricImage } from '@/core/components';

import ImageAssemblerFabricImageInfo
  from '@/teams/visionair/components/ImageAssembler/ImageAssemblerFabricImageInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAssemblerFabricImage',
  props: {
  index: {
    type: Number,
    default: null,
  },
  position: {
    type: Number,
    required: true,
  },
  image: {
    type: Object as PropType<InspectionImage>,
    required: true,
  },
},
  setup(__props) {

const props = __props


const injectedAssemblerRoot = inject<AssemblerRootExposition>('injectedAssemblerRoot') as AssemblerRootExposition;
const injectedFabric = inject<FabricExposition>(injectionKey);
const injectedImageAssembler: any = inject(
  'imageAssembler',
);
const groupRef = ref();
const imageRef = ref();
const uiRef = ref();
const infos = ref({
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  scaleX: 1,
  scaleY: 1,
  angle: 0,
});

const updateInfos = () => {
  groupRef.value.deferredObject.promise.then((object: fabric.Group) => {
    infos.value = {
      left: object.left || 0,
      top: object.top || 0,
      width: object.width || 0,
      height: object.height || 0,
      scaleX: object.scaleX || 1,
      scaleY: object.scaleY || 1,
      angle: object.angle || 0,
    };
  });
};
const infoLineHeight = 32;
const infoLineSpacing = 2;
const infoFontSize = 14;
const infoTexts = computed(() => {
  const {
    width,
    height,
    scaleY,
    scaleX,
    angle,
  } = infos.value;
  return [
    `${props.index}`
    // `# ${props.image.id}`,
    // `Angle: ${Math.round((angle || 0) * 10) / 10}`,
    // `Width: ${Math.round((width || 0) * scaleX)}`,
    // `Height: ${Math.round((height || 0) * scaleY)}`,
    // `Scale: ${Math.round((scaleX ?? 1) * 100) / 100}`,
    // `Base Width: ${Math.round(width || 0)}`,
    // `Base Height: ${Math.round(height || 0)}`,
  ];
});

onMounted(() => {
  const canvas = injectedFabric?.getCanvas();
  // eslint-disable-next-line no-new,no-async-promise-executor
  new Promise<{
    group: fabric.Group
    image: fabric.Image
    ui: fabric.Group
    // eslint-disable-next-line no-async-promise-executor
  }>(async (resolve, reject) => {
    try {
      resolve({
        group: await groupRef.value.deferredObject.promise,
        image: await imageRef.value.deferredObject.promise,
        ui: await uiRef.value.deferredObject.promise,
      });
    } catch (e) {
      reject(e);
    }
  }).then(({
    group,
    ui,
  }) => {
    group.setControlsVisibility({
      mt: false, // middle top disable
      mb: false, // midle bottom
      ml: false, // middle left
      mr: false, // I think you get it
    });
    const scale = () => {
      if (canvas) {
        ui.set({
          scaleX: 1 / (group.scaleX as number) / canvas.getZoom(),
          scaleY: 1 / (group.scaleY as number) / canvas.getZoom(),
        });
      }
    };
    group?.on('selected', (e) => {
      injectedImageAssembler.selectedImage.value = props.image.id;
    });
    group?.on('deselected', (e) => {
      injectedImageAssembler.selectedImage.value = null;
    });
    ['rotating', 'scaling', 'moving', 'skewing', 'modified', 'added'].forEach((event) => {
      group?.on(event, () => {
        updateInfos();
      });
    });
    ['mouse:wheel', 'object:scaling', 'pan'].forEach((event) => {
      canvas?.on(event, () => {
        scale();
      });
    });
    scale();
    updateInfos();
    injectedAssemblerRoot.centerView();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkFabricGroup), {
    ref_key: "groupRef",
    ref: groupRef,
    options: {
      angle: props.image.angle,
      top: props.image.y,
      left: props.image.x,
      scaleX: props.image.ratio,
      scaleY: props.image.ratio,
      lockSkewingX: true,
      lockSkewingY: true,
      lockScalingFlip: true,
      lockUniScaling: true,
      centeredRotation: true,
      id: props.image.id,
    },
    position: props.position
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NkFabricImage), {
        ref_key: "imageRef",
        ref: imageRef,
        options: {
        top: 0,
        left: 0,
      },
        url: props.image.assemblerImage,
        position: 0
      }, null, 8, ["url"]),
      _createVNode(_unref(NkFabricGroup), {
        ref_key: "uiRef",
        ref: uiRef,
        options: {
        top: 0,
        left: 0,
        backgroundColor: 'red',
      },
        position: 1
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoTexts), (line, i) => {
            return (_openBlock(), _createBlock(ImageAssemblerFabricImageInfo, {
              key: i,
              fontSize: infoFontSize,
              line: i,
              lineHeight: infoLineHeight,
              lineSpacing: infoLineSpacing,
              text: line
            }, null, 8, ["line", "text"]))
          }), 128))
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["options", "position"]))
}
}

})